module.exports = __webpack_public_path__ + "img/map-marker.51951c17.svg";